module.exports = __webpack_public_path__ + "img/star-3.19462ba0.svg";